document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cf-file-preview-container').forEach(function(dropzone) {
    // Click to open file dialog
    dropzone.addEventListener('click', function(e) {
      // Only trigger if not clicking the actual input
      if (e.target !== dropzone) return;
      var input = dropzone.querySelector('input[type="file"]');
      if (input) input.click();
    });
    // Show file name below the custom file button
    var fileInput = dropzone.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.addEventListener('change', function() {
        var fileNameSpan = dropzone.querySelector('.file-name');
        if (!fileNameSpan) {
          fileNameSpan = document.createElement('span');
          fileNameSpan.className = 'file-name';
          var label = dropzone.querySelector('.custom-file-label');
          if (label && label.nextSibling) {
            label.parentNode.insertBefore(fileNameSpan, label.nextSibling);
          } else {
            dropzone.appendChild(fileNameSpan);
          }
        }
        if (fileInput.files && fileInput.files.length > 0) {
          fileNameSpan.textContent = fileInput.files[0].name;
        } else {
          fileNameSpan.textContent = '';
        }
      });
    }
    // Drag and drop highlight
    dropzone.addEventListener('dragover', function(e) {
      e.preventDefault();
      dropzone.classList.add('dragover');
    });
    dropzone.addEventListener('dragleave', function(e) {
      dropzone.classList.remove('dragover');
    });
    dropzone.addEventListener('drop', function(e) {
      e.preventDefault();
      dropzone.classList.remove('dragover');
      var input = dropzone.querySelector('input[type="file"]');
      if (input && e.dataTransfer && e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        // Optionally, trigger change event
        var event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
      }
    });
  });
});

document.querySelectorAll('.custom-file-dropzone').forEach(input => {
  const container = input.closest('.cf-file-preview-container');
  input.addEventListener('change', function() {
    if (input.files.length) {
      container.classList.add('has-file');
      container.setAttribute('data-file', input.files[0].name);
      container.innerHTML = `<span style=\"color:#b98a6a;\">${input.files[0].name}</span>`;
    } else {
      container.classList.remove('has-file');
      container.innerHTML = '';
    }
    container.appendChild(input); // re-attach input
  });

  // Drag & drop effect
  container.addEventListener('dragover', e => {
    e.preventDefault();
    container.classList.add('dragover');
  });
  container.addEventListener('dragleave', e => {
    container.classList.remove('dragover');
  });
  container.addEventListener('drop', e => {
    container.classList.remove('dragover');
  });
});

document.addEventListener('modalClosed', function() {
  var lastActive = document.activeElement;
  if (lastActive && lastActive.classList.contains('custom-popup-btn')) {
    lastActive.blur();
  }
});

/* ----------------------------------------------------------------
   Klaviyo Back-in-Stock: prevent the native sold-out button from
   competing with Klaviyo without delaying the in-stock Add-to-cart.

   ProductWiz/Rio also handles variant changes on this product, so
   timing variant events is brittle. This block only reflects current
   DOM state:
   - If Klaviyo's BiS container exists, tag the row so CSS hides the
     native [name="add"] button behind the Notify Me button.
   - If the native button is disabled or says "Sold Out", tag it as a
     sold-out state so CSS hides it while Klaviyo prepares Notify Me.
   - If Klaviyo unhides the native button for an in-stock variant,
     immediately normalize its text to "Add to Cart".
----------------------------------------------------------------- */
(function () {
  var FLAG = 'klaviyoBisActive';
  var ROW_CLASS = 'kioma-bis-row-active';
  var SOLD_OUT_CLASS = 'kioma-native-sold-out-state';

  function getAddButtons() {
    return document.querySelectorAll('.product-form__buttons-row [name="add"]');
  }

  function getButtonText(button) {
    var span = button.querySelector('span');
    return span ? span.textContent.trim() : '';
  }

  function setButtonText(button, text) {
    var span = button.querySelector('span');
    if (span && text && span.textContent.trim() !== text) {
      span.textContent = text;
    }
  }

  function buttonLooksSoldOut(button) {
    var soldOutText = window.variantStrings && window.variantStrings.soldOut;
    return button.disabled || (soldOutText && getButtonText(button) === soldOutText);
  }

  function refreshKlaviyoRowsAndButtonStates() {
    var containers = document.querySelectorAll('#klaviyo-bis-button-container');

    document.querySelectorAll('.' + ROW_CLASS).forEach(function(row) {
      row.classList.remove(ROW_CLASS);
    });

    containers.forEach(function(container) {
      var row = container.closest('.product-form__buttons-row');
      if (row) row.classList.add(ROW_CLASS);
    });

    if (containers.length) {
      document.documentElement.dataset[FLAG] = 'true';
    }

    getAddButtons().forEach(function(button) {
      button.classList.toggle(SOLD_OUT_CLASS, buttonLooksSoldOut(button));
    });
  }

  function isKlaviyoHiddenStyle(value) {
    return !!value && /display\s*:\s*none/i.test(value);
  }

  function normalizeAfterKlaviyoUnhide(button) {
    var addText = window.variantStrings && window.variantStrings.addToCart;
    if (!addText) return;

    // Klaviyo removes its inline display:none only when it is handing
    // control back to the native in-stock button. Make that button
    // visible immediately instead of waiting for Rio/theme async work.
    button.classList.remove(SOLD_OUT_CLASS);
    button.removeAttribute('disabled');
    setButtonText(button, addText);
  }

  refreshKlaviyoRowsAndButtonStates();

  if (typeof MutationObserver === 'function') {
    var pageObserver = new MutationObserver(refreshKlaviyoRowsAndButtonStates);
    pageObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    var buttonObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var button = mutation.target;
        if (!button || button.nodeType !== 1 || !button.matches('[name="add"]')) {
          return;
        }

        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style' &&
          isKlaviyoHiddenStyle(mutation.oldValue) &&
          !isKlaviyoHiddenStyle(button.getAttribute('style'))
        ) {
          normalizeAfterKlaviyoUnhide(button);
        }

        button.classList.toggle(SOLD_OUT_CLASS, buttonLooksSoldOut(button));
      });
    });

    function observeButtons() {
      getAddButtons().forEach(function(button) {
        buttonObserver.observe(button, {
          attributes: true,
          attributeOldValue: true,
          attributeFilter: ['disabled', 'style'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      });
      refreshKlaviyoRowsAndButtonStates();
    }

    observeButtons();
    new MutationObserver(observeButtons).observe(
      document.body || document.documentElement,
      { childList: true, subtree: true }
    );
  }
})();

/* ----------------------------------------------------------------
   Disable ProductWiz hover magnify UI only when "Enable image zoom"
   is off. Do NOT mutate __productWizRio.config — that broke the app
   settings. CSS (.product--disable-image-zoom) + removing Drift panes
   is enough for the education template.
----------------------------------------------------------------- */
(function () {
  function shouldDisable() {
    return !!document.querySelector('[data-disable-image-zoom="true"]');
  }

  function removeDriftPanes() {
    if (!shouldDisable()) return;
    document
      .querySelectorAll('.pwzrdrift-zoom-pane, .pwzrdrift-zoom-pane-loader')
      .forEach(function (el) {
        el.remove();
      });
  }

  removeDriftPanes();
  document.addEventListener('DOMContentLoaded', removeDriftPanes);

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    removeDriftPanes();
    if (tries > 40) clearInterval(timer);
  }, 150);

  if (typeof MutationObserver === 'function') {
    new MutationObserver(function () {
      removeDriftPanes();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

